/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowUp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M207.39111,115.06152A8.00065,8.00065,0,0,1,200,120H136v96a8,8,0,0,1-16,0V120H56a8.0001,8.0001,0,0,1-5.65674-13.65723l72-72a8.00182,8.00182,0,0,1,11.31348,0l72,72A8.00148,8.00148,0,0,1,207.39111,115.06152Z" />
    </Svg>
  );
}

export default ArrowUp;
